import { useCallback } from "react";
import useAjax from "@apis/useAjax";
import { checkResponse } from "@apis/utils";
import { GET_GIFT_ITEM_ENABLED_API, GET_GIFT_ITEM_OPTIONS_API, GET_GIFT_ITEM_OVERVIEW_API, POST_GIFT_ITEM_API, PUT_GIFT_ITEM_API, PUT_GIFT_ITEM_ENABLED_API } from "@apis/apiPath";

// 贈品相關
const useGiftItemApi = () => {
	const Ajax = useAjax();

	const getGiftItemEnabledApi = useCallback(
		async () => {
			const resp = await Ajax.get(GET_GIFT_ITEM_ENABLED_API);
			if (checkResponse(resp)) return resp;
			return false;
		},
		// eslint-disable-next-line
		[]
	);

	const getGiftItemOptionsApi = useCallback(
		async () => {
			const resp = await Ajax.get(GET_GIFT_ITEM_OPTIONS_API);
			if (checkResponse(resp)) return resp;
			return false;
		},
		// eslint-disable-next-line
		[]
	);

	const getGiftItemOverviewApi = useCallback(
		async params => {
			const resp = await Ajax.get(GET_GIFT_ITEM_OVERVIEW_API, params);
			if (checkResponse(resp)) return resp;
			return false;
		},
		// eslint-disable-next-line
		[]
	);

	const postGiftItemApi = useCallback(
		async params => {
			const resp = await Ajax.post(POST_GIFT_ITEM_API, params);
			if (checkResponse(resp)) return resp;
			return false;
		},
		// eslint-disable-next-line
		[]
	);

	const putGiftItemApi = useCallback(
		async (giftID, params) => {
			const resp = await Ajax.put(PUT_GIFT_ITEM_API(giftID), params);
			if (checkResponse(resp)) return resp;
			return false;
		},
		// eslint-disable-next-line
		[]
	);

	const putGiftItemEnabledApi = useCallback(
		async (giftID, params) => {
			const resp = await Ajax.put(PUT_GIFT_ITEM_ENABLED_API(giftID), params);
			if (checkResponse(resp)) return resp;
			return false;
		},
		// eslint-disable-next-line
		[]
	);

	return {
		getGiftItemEnabledApi,
		getGiftItemOptionsApi,
		getGiftItemOverviewApi,
		postGiftItemApi,
		putGiftItemApi,
		putGiftItemEnabledApi,
	};
};

export default useGiftItemApi;
